import httpService from "./httpService";

export default {
  findByDocId(docId) {
    return httpService.get("vbOpinionForm/findByDocId", {params: {docId}});
  },

  findByDocIdAndUser(docId, userDeptRoleId) {
    return httpService.get("vbOpinionForm/findByDocIdAndUser", {
      params: {docId, userDeptRoleId}
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/vbOpinionFormService.js